export default "__VITE_ASSET__BKQc5Bx0__"